import { LocaleString } from "models/locale";
import { doGet, doPatch, doPost, parseListPath } from "../request";
import { List } from "models/list";

export const adminDoGetLists = async () => {
  const lists = await doGet<List[]>("/admin/lists");
  return lists;
};

export const adminDoGetList = async (listUuid: string) => {
  const list = await doGet<List>(`/admin/list/${listUuid}`);
  return list;
};

// list creation
export const adminDoPostList = async (
  name: LocaleString,
  list_template_uuid: string,
) => {
  const list = await doPost<List>(`/admin/list`, { name, list_template_uuid });
  return list;
};

export const adminDoPatchList = async (list: List, data: Partial<List>) => {
  const l = await doPatch<List>(parseListPath(list), data);
  return l;
};
